import styled, { css } from 'styled-components';
import { variant } from 'styled-system';

import { ThemeUtilities } from '../../../theme';
import { ComponentSize } from '../types';
import { fontSmoothing } from '../../../mixins';

export const StyledAnchor = styled.a<{
  size: ComponentSize;
  disabled: boolean;
}>`
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  ${fontSmoothing};

  &:hover {
    text-decoration: underline;
  }

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Anchor', 'size'))};
  ${({ disabled, theme }) =>
    disabled &&
    css`
      cursor: not-allowed;
      color: ${theme.colors.primary.light};
      &:hover {
        color: ${theme.colors.primary.light};
        text-decoration: none;
      }
    `};

  ${css((props) => ThemeUtilities.getComponentCSSOverrides(props, 'Anchor'))};
`;

export const IconContainer = styled.div<{
  iconSize: ComponentSize;
}>`
  display: flex;
  justify-content: center;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Anchor', 'iconSize'))};
`;
